// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__24-Vw","vLegacy":"SelectSecondary_vLegacy__261To","error":"SelectSecondary_error__bCtxx","disabled":"SelectSecondary_disabled__3cAaW"};